const NewInfoDescription = ({ contents }) => (
    <div className='ml-4 mb-4'>
        <ul className='list-disc list-outside text-left text-xs text-gray-500'>
            {contents.map((e, i) => <li key={i}>{e}</li>)}
        </ul>
    </div>
)

export default NewInfoDescription